// SVG de pena/escrita
const FeatherIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20.24 12.24a6 6 0 0 0-8.49-8.49L5 10.5V19h8.5z" />
    <line x1="16" y1="8" x2="2" y2="22" />
    <line x1="17.5" y1="15" x2="9" y2="15" />
  </svg>
);

export default function DailyCounter({ count, loading }) {
  return (
    <div className="daily-counter">
      <div className="daily-counter-icon">
        <FeatherIcon />
      </div>
      <div className="daily-counter-body">
        <div className="daily-counter-number">
          {loading ? '—' : count}
        </div>
        <div className="daily-counter-label">
          {count === 1
            ? 'pessoa escreveu hoje no Clube do Eu'
            : 'pessoas escreveram hoje no Clube do Eu'}
        </div>
      </div>
      <div className="daily-counter-pulse" title="Ao vivo" />
    </div>
  );
}
